/**
 * Quote Model
 * @param { object } vehicleInfos - Vehicle Object with all infos.
 * @param { object } showroomPaymentOptions - Payment Options Object with all infos.
 * @param { string } category - Vehicle category - catalog or inventory (default: inventory)
 */
export const quoteModelTransform = (vehicleInfos, showroomPaymentOptions, category = 'inventory') => {
    if (category === 'catalog') return quoteModelCatalogTransform(vehicleInfos, showroomPaymentOptions)
    else return quoteModelInventoryTransform(vehicleInfos, showroomPaymentOptions)
}

/**
 * Quote Model Inventory
 * @param { object } vehicleInfos - Vehicle Object with all infos.
 * @param { object } showroomPaymentOptions - Payment Options Object with all infos.
 */
const quoteModelInventoryTransform = (vehicleInfos, showroomPaymentOptions) => {
    const { year, make, model, vehicleId, configurationId, odometer, vin, stockNumber, modelTrimCode, showroomVehicleId } =
        vehicleInfos || {}

    const {
        transactionToken,
        purchaseMethod,
        saleType,
        taxPlan,
        lien,
        cashDown,
        tradeIn,
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        term,
        vehicleCondition,
        cashPurchase,
    } = showroomPaymentOptions || {}

    return {
        year,
        make,
        model,
        vehicleId,
        stockNumber,
        transactionTokenCopy: transactionToken,
        purchaseMethod,
        saleType,
        taxPlan,
        configurationId,
        modelTrimCode,
        lien,
        cashDown,
        showroomVehicleId,
        tradeIn,
        financePlan,
        odometer,
        vin,
        kmPerYearPlan,
        paymentFrequency,
        term,
        vehicleCondition,
        retail: cashPurchase?.retailDetails?.msrp,
        sellingPrice: cashPurchase?.sellingPrice,
    }
}

/**
 * Quote Model Catalog
 * @param { object } vehicleInfos - Vehicle Object with all infos.
 * @param { object } showroomPaymentOptions - Payment Options Object with all infos.
 */
const quoteModelCatalogTransform = (vehicleInfos, showroomPaymentOptions) => {
    const {
        transactionToken,
        purchaseMethod,
        saleType,
        taxPlan,
        lien,
        cashDown,
        tradeIn,
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        term,
        vehicleCondition,
        cashPurchaseOption,
    } = showroomPaymentOptions || {}

    const { transaction = [] } = cashPurchaseOption || {}

    const base = transaction?.find(({ category }) => category === 'base') || {}
    const sellingPrice = transaction.find(({ category }) => category === 'total')?.amount || 0

    const retail = base?.items.find(({ description }) => description === 'MSRP')?.amount || 0

    const { year, make, model, vehicleId, modelTrimCode, configurationId } = vehicleInfos || {}

    return {
        year,
        make,
        model,
        vehicleId,
        transactionToken,
        purchaseMethod,
        saleType,
        taxPlan,
        lien,
        cashDown,
        tradeIn,
        financePlan,
        kmPerYearPlan,
        paymentFrequency,
        term,
        retail,
        sellingPrice,
        vehicleCondition,
        modelTrimCode,
        configurationId,
    }
}
